(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('locationService', locationService);

    locationService.$inject = ['$http', 'CONFIG', 'messageService', 'linkService'];


    function locationService($http, CONFIG, messageService, linkService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FLIGHT_CONTROL + '/' + CONFIG.API + '/airports/offer/list';
        
        var service = {
            getLocations: getLocations,
            getFirstId: getFirstId
        };

        return service;

        function getLocations() {
            return $http.get(urlBase)
                .then(function(response) {
                    if (response.data._embedded) {
                        var airports = response.data._embedded.airports;
                        var optionsArray = airports.map(function(airport) {
                            var id = parseInt(linkService.getLinkId(airport._links.self.href));
                            var name = airport._embedded.region.name;
                            return { id: id, name: name };
                        });
                        return optionsArray;
                    }
                })
                .catch(function() {
                    messageService.findAllError('');
                });
        }
        
        function getFirstId() {
            return $http.get(urlBase)
                .then(function(response) {
                    if (response.data._embedded) {
                        var airport = response.data._embedded.airports[0];
                        return linkService.getLinkId(airport._links.self.href);
                    }
                })
                .catch(function() {
                    messageService.findAError('');
                });
        }
    }
})();